import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectCoop } from "../../selectors/selectCoopInfo";
import { selectActiveCoopProjectResources } from "../../selectors/selectCoopProjectInfo";
import { Badge } from "../generic/badge/Badge";
import { IdBadgePosition } from "../generic/badge/IdBadgePosition";
import { Button } from "../generic/button/Button";
import { IconWithModifier } from "../generic/icon-with-modifier/IconWithModifier";
import { getResourceIcon } from "../generic/icon/getResourceIcon";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { actionCoopMenuTabGoTo } from "./actionCoop";
import { IdCoopCategory } from "./IdCoopCategory";
var _HudButtonCooperativeFlag = function (_a) {
    var activeProjectResources = _a.activeProjectResources, onCoopProjectTabOpen = _a.onCoopProjectTabOpen, coop = _a.coop;
    if (coop == undefined) {
        return React.createElement(React.Fragment, null);
    }
    var iconElement = React.createElement(Icon, { icon: IdIcon.InactiveOutlinedIcn, styleId: IdStyles.IconMedium });
    var flagIconClass = "pt__medium";
    if (activeProjectResources.length) {
        var areMultipleResources = activeProjectResources.length === 2;
        // Only handling 1 or 2 resources to bake the icon
        var modifierIconProps = void 0;
        if (areMultipleResources) {
            modifierIconProps = {
                icon: getResourceIcon(activeProjectResources[1]),
                position: IdBadgePosition.BottomLeft,
                styleId: IdStyles.IconSmall,
            };
            flagIconClass = "pl__large";
        }
        iconElement = (React.createElement(IconWithModifier, { styleId: areMultipleResources ? IdStyles.IconSmall : IdStyles.IconMedium, icon: getResourceIcon(activeProjectResources[0]), modifierIconProps: modifierIconProps }));
    }
    return (React.createElement(Button, { onClick: onCoopProjectTabOpen, className: "flex" },
        React.createElement(Badge, { position: IdBadgePosition.ExtremeRight },
            React.createElement(Icon, { styleId: IdStyles.IconExtraLarge, icon: IdIcon.CoopFlag },
                React.createElement("div", { className: "flex flex--guts h100 w100 pl__medium pb__medium " + flagIconClass }, iconElement)))));
};
var mapState = function (state) { return ({
    activeProjectResources: selectActiveCoopProjectResources(state),
    coop: selectCoop(state),
}); };
var mapDispatch = function (dispatch) { return ({
    onCoopProjectTabOpen: function () {
        dispatch(actionCoopMenuTabGoTo(IdCoopCategory.CoopProjects));
    },
}); };
export var HudButtonCooperativeFlag = connect(mapState, mapDispatch)(_HudButtonCooperativeFlag);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/HudButtonCooperativeFlag.tsx
// module id = 2267
// module chunks = 3